import { useHistory } from "react-router-dom";
import { post,get } from 'helpers/api_helper';

export function useParentingSpace() {
  const history = useHistory(); // Use history for navigation

  const createParentingSpace = async (role) => {
    try {
      const data = await post('/api/create-space', { role });
      if (data.active_parenting_space) {
        localStorage.setItem('active_parenting_space_id', data.active_parenting_space.id); // Store the ID in localStorage
        localStorage.setItem('active_parenting_space', JSON.stringify(data.active_parenting_space)); // Store the active_parenting_space object in localStorage
        history.push("/"); // Redirect to /
      } else {
        throw new Error("Invalid response from server while creating parenting space.");
      }
    } catch (error) {
      throw error; // Handle error appropriately
    }
  };


  const getInvitedParentingSpaces = async () => {
    try {
      const data = await get('/api/spaces/get-user-invite-list');
      if (data && data.invites) {
        return data.invites; // Return the list of invited parenting spaces
      }else {
        throw new Error("No invited parenting spaces found.");
      }
    } catch (error) {
      throw error; // Handle error appropriately
    }
  };

  const joinParentingSpace = async (inviteID) => {
    try {
      const data = await post('/api/spaces/join-space', { invite_id:inviteID });
      if (data.active_parenting_space) {
        localStorage.setItem('active_parenting_space_id', data.active_parenting_space.id); // Store the ID in localStorage
        localStorage.setItem('active_parenting_space', JSON.stringify(data.active_parenting_space)); // Store the active_parenting_space object in localStorage
        history.push("/"); // Redirect to /
      } else {
        throw new Error("Invalid response from server while joining parenting space.");
      }
    } catch (error) {
      throw error; // Handle error appropriately
    }
  };

  const inviteToParentingSpace = async (email, role) => {
    try {
      const data = await post('/api/spaces/invite-user', { email, role });
      if (data.invite) {
        // Handle successful invite
        console.log("Invite sent successfully.");
      } else {
        throw new Error("Invalid response from server while inviting to parenting space.");
      }
    } catch (error) {
      throw error; // Handle error appropriately
    }
  };

  const getParentingSpaceUsers = async () => {
    try {
      const data = await get('/api/spaces/get-user-list');
      if (data && data.users) {
        return data.users; // Return the list of parenting space users
      }else {
        throw new Error("No parenting space users found.");
      }
    } catch (error) {
      throw error; // Handle error appropriately
    }
  };


  return { createParentingSpace, getInvitedParentingSpaces,joinParentingSpace,inviteToParentingSpace,getParentingSpaceUsers };
}
